import ErrorIndicator from './Error-Indicator';

export default ErrorIndicator;